import {
  type ColumnType,
  type Selectable,
  type Insertable,
  type Updateable,
} from 'kysely'
import { z } from 'zod'

/** Identifier type for public.contact_submission_ */
export type ContactSubmissionId = string & { __brand: 'ContactSubmissionId' }

/** Represents the table public.contact_submission_ */
export default interface ContactSubmissionTable {
  /** Database type: pg_catalog.uuid */
  id: ColumnType<
    ContactSubmissionId,
    ContactSubmissionId | undefined,
    ContactSubmissionId
  >

  /** Database type: pg_catalog.timestamptz */
  createdAt: ColumnType<Date | null, Date | string | null, Date | string | null>

  /** Database type: pg_catalog.uuid */
  createdBy: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.timestamptz */
  updatedAt: ColumnType<Date | null, Date | string | null, Date | string | null>

  /** Database type: pg_catalog.uuid */
  updatedBy: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.timestamptz */
  deletedAt: ColumnType<Date | null, Date | string | null, Date | string | null>

  /** Database type: pg_catalog.uuid */
  deletedBy: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.text */
  name: ColumnType<string, string, string>

  /** Database type: pg_catalog.text */
  email: ColumnType<string, string, string>

  /** Database type: pg_catalog.text */
  message: ColumnType<string, string, string>

  /** Database type: pg_catalog.inet */
  ipAddress: ColumnType<string, string, string>

  /** Database type: pg_catalog.bool */
  read: ColumnType<boolean, boolean | undefined, boolean>
}

export type ContactSubmission = Selectable<ContactSubmissionTable>

export type ContactSubmissionInitializer = Insertable<ContactSubmissionTable>

export type ContactSubmissionMutator = Updateable<ContactSubmissionTable>

export const contactSubmissionId =
  z.string() as unknown as z.Schema<ContactSubmissionId>

export const contactSubmission = z.object({
  id: contactSubmissionId,
  createdAt: z.coerce.date().nullable().optional(),
  createdBy: z.string().nullable().optional(),
  updatedAt: z.coerce.date().nullable().optional(),
  updatedBy: z.string().nullable().optional(),
  deletedAt: z.coerce.date().nullable().optional(),
  deletedBy: z.string().nullable().optional(),
  name: z.string(),
  email: z.string(),
  message: z.string(),
  ipAddress: z.string(),
  read: z.boolean(),
}) as unknown as z.Schema<ContactSubmission>

export const contactSubmissionInitializer = z.object({
  id: contactSubmissionId.optional(),
  createdAt: z.coerce.date().optional().nullable(),
  createdBy: z.string().optional().nullable(),
  updatedAt: z.coerce.date().optional().nullable(),
  updatedBy: z.string().optional().nullable(),
  deletedAt: z.coerce.date().optional().nullable(),
  deletedBy: z.string().optional().nullable(),
  name: z.string(),
  email: z.string(),
  message: z.string(),
  ipAddress: z.string(),
  read: z.boolean().optional(),
}) as unknown as z.Schema<ContactSubmissionInitializer>

export const contactSubmissionMutator = z.object({
  id: contactSubmissionId.optional(),
  createdAt: z.coerce.date().optional().nullable(),
  createdBy: z.string().optional().nullable(),
  updatedAt: z.coerce.date().optional().nullable(),
  updatedBy: z.string().optional().nullable(),
  deletedAt: z.coerce.date().optional().nullable(),
  deletedBy: z.string().optional().nullable(),
  name: z.string().optional(),
  email: z.string().optional(),
  message: z.string().optional(),
  ipAddress: z.string().optional(),
  read: z.boolean().optional(),
}) as unknown as z.Schema<ContactSubmissionMutator>
